'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  password: {
    button: {
      login: 'Login'
    },
    email: {
      meta_title: 'Caligram - Forgot password',
      title: 'Forgot password',
      help: 'Enter you email address and you will receive a link to reset your password.',
      form: {
        email: 'Email',
        submit: 'Submit'
      }
    },
    reset: {
      meta_title: 'Caligram - Reset your password',
      title: 'Reset your password',
      form: {
        email: 'Email',
        password: 'Password',
        submit: 'Reset'
      }
    }
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/password.js
// module id = 2286
// module chunks = 0